module.exports = __webpack_public_path__ + "img/2.7d5b1f16.png";